import type { ApolloClient } from '@apollo/client';
import React, { ReactElement } from 'react';
import { SIDE_PANEL_IDS } from '../../constants/constants';
import I18n from '../../i18n/I18n';
import { Icons } from '../../icons/Icons';
import { EntityShareSettings, ShareableEntity, ShareSettingsProvider } from '../../share';

type EntityShareSettingsParams = {
    entityId: string | null;
    entity: ShareableEntity | null;
    title?: string | ReactElement;
    isLoading?: boolean;
    onClose?: () => void;
    onAfterShareSettingsSave?: () => Promise<unknown> | void;
    makeShareSettingsScopeId: (entityId: string) => string;
    deepLinkUIStatePath?: string;
};

type EntityShareSettingsPanelParams = {
    client: ApolloClient<object>;
    id?: string;
    label?: ReactElement;
    disabled?: boolean;
    hidden?: boolean;
    shareSettingsParams: EntityShareSettingsParams;
};

export const getEntityShareSettingsPanelConfig = ({
    client,
    id = SIDE_PANEL_IDS.share,
    label = <I18n token="share" />,
    disabled = false,
    hidden = false,
    shareSettingsParams
}: EntityShareSettingsPanelParams) => {
    return {
        id,
        icon: Icons.Share,
        label,
        disabled,
        hidden,
        component: (onClose) => {
            return (
                <ShareSettingsProvider throwOnError client={client}>
                    <EntityShareSettings
                        entityId={shareSettingsParams.entityId}
                        entity={shareSettingsParams.entity}
                        title={shareSettingsParams.title}
                        isLoading={shareSettingsParams.isLoading}
                        onClose={() => {
                            shareSettingsParams.onClose?.();
                            onClose();
                        }}
                        onAfterShareSettingsSave={shareSettingsParams.onAfterShareSettingsSave}
                        makeShareSettingsScopeId={shareSettingsParams.makeShareSettingsScopeId}
                        deepLinkUIStatePath={shareSettingsParams.deepLinkUIStatePath}
                    />
                </ShareSettingsProvider>
            );
        }
    };
};
